// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-pages-usageReportingContainer-components-tripStatusQueriesTable-module__wrapper--REAgB {
  border-radius: 4px;
  overflow: hidden;
}

.src-js-pages-usageReportingContainer-components-tripStatusQueriesTable-module__scrollArea--C9LH2 {
  overflow-x: auto;
  overflow-y: auto;
  /* Show header + 7 data rows (~44px each); scroll vertically beyond that. */
  max-height: 352px;
  /* Figma scrollbar theme (Firefox) */
  scrollbar-width: thin;
  scrollbar-color: #8a97a4 transparent;
}

/* Figma scrollbar theme (WebKit / Chromium) */
.src-js-pages-usageReportingContainer-components-tripStatusQueriesTable-module__scrollArea--C9LH2::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.src-js-pages-usageReportingContainer-components-tripStatusQueriesTable-module__scrollArea--C9LH2::-webkit-scrollbar-track {
  background: transparent;
}

.src-js-pages-usageReportingContainer-components-tripStatusQueriesTable-module__scrollArea--C9LH2::-webkit-scrollbar-thumb {
  background-color: #8a97a4;
  border-radius: 6px;
}

.src-js-pages-usageReportingContainer-components-tripStatusQueriesTable-module__scrollArea--C9LH2::-webkit-scrollbar-thumb:hover {
  background-color: #6f7d8c;
}

.src-js-pages-usageReportingContainer-components-tripStatusQueriesTable-module__scrollArea--C9LH2::-webkit-scrollbar-corner {
  background: transparent;
}

/* Keep the column headers visible while the body scrolls. */
.src-js-pages-usageReportingContainer-components-tripStatusQueriesTable-module__scrollArea--C9LH2 thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #445566;
}

.src-js-pages-usageReportingContainer-components-tripStatusQueriesTable-module__firstCol--hoAGK {
  text-align: left !important;
  white-space: nowrap;
  min-width: 140px;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/usageReportingContainer/components/tripStatusQueriesTable.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,2EAA2E;EAC3E,iBAAiB;EACjB,oCAAoC;EACpC,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,8CAA8C;AAC9C;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":[".wrapper {\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.scrollArea {\n  overflow-x: auto;\n  overflow-y: auto;\n  /* Show header + 7 data rows (~44px each); scroll vertically beyond that. */\n  max-height: 352px;\n  /* Figma scrollbar theme (Firefox) */\n  scrollbar-width: thin;\n  scrollbar-color: #8a97a4 transparent;\n}\n\n/* Figma scrollbar theme (WebKit / Chromium) */\n.scrollArea::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.scrollArea::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.scrollArea::-webkit-scrollbar-thumb {\n  background-color: #8a97a4;\n  border-radius: 6px;\n}\n\n.scrollArea::-webkit-scrollbar-thumb:hover {\n  background-color: #6f7d8c;\n}\n\n.scrollArea::-webkit-scrollbar-corner {\n  background: transparent;\n}\n\n/* Keep the column headers visible while the body scrolls. */\n.scrollArea thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background-color: #445566;\n}\n\n.firstCol {\n  text-align: left !important;\n  white-space: nowrap;\n  min-width: 140px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `src-js-pages-usageReportingContainer-components-tripStatusQueriesTable-module__wrapper--REAgB`,
	"scrollArea": `src-js-pages-usageReportingContainer-components-tripStatusQueriesTable-module__scrollArea--C9LH2`,
	"firstCol": `src-js-pages-usageReportingContainer-components-tripStatusQueriesTable-module__firstCol--hoAGK`
};
export default ___CSS_LOADER_EXPORT___;
